import { render, staticRenderFns } from "./WarehouseDocumentGroceriesTable.vue?vue&type=template&id=536fda6c"
import script from "./WarehouseDocumentGroceriesTable.vue?vue&type=script&lang=js"
export * from "./WarehouseDocumentGroceriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports